export const DEFAULT_MAP_ZOOM = 11;

export type Geometry = { type?: string; [key: string]: unknown } | null | undefined;

export const ValidGeometryTypes = new Set([
  'Point',
  'MultiPoint',
  'LineString',
  'MultiLineString',
  'Polygon',
  'MultiPolygon',
  'GeometryCollection',
]);

export type MapMetadata = {
  zoomlevel: number;
  centerlat: number;
  centerlng: number;
  minlat: number;
  minlng: number;
  maxlat: number;
  maxlng: number;
};

export type GestureHandling = 'cooperative' | 'greedy' | 'none' | 'auto';
